var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"container-fluid p-0 mb-12"},[_c('b-overlay',{attrs:{"show":_vm.$store.state.app.showLoader,"rounded":"sm"}},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }